<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner">
      <vue-custom-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-y="scrollHanle"
      >
        <form action="search" class="mobile-view">
          <!----
          <input class="form-control" type="text" placeholder="Search here" />
          <button class="btn" type="button">
            <i class="fa fa-search"></i>
          </button>
          --->
        </form>
        <div id="sidebar-menu" class="sidebar-menu" Y>
          <!---<ul>
            <li class="nav-item nav-profile">
              <v-list-item dense style="background-color: #fff;;">
                <img v-if="checkuserimg(userimage)" :src="userimage" />
                <v-avatar color="blue" v-if="checkimg(userimage)">
                  <div style="font-size: 24px;">
                    {{ username.substring(0, 1) }}
                  </div>
                </v-avatar>
                <v-spacer></v-spacer> <span class="font-weight-bold mb-0" style="color:#000">{{ username }}</span><v-spacer></v-spacer>
              </v-list-item>
            </li>
          </ul>-->
          <v-list-item
            dense
            v-for="item in menuList"
            :key="item.sequence"
            @mouseout="onItemClick(item)"
            :style="{
              backgroundColor: isActive === item ? '#e6f2ff' : '',
            }"
          >
            <v-icon>{{ item.weburl_value }}</v-icon>
            <router-link :to="`${item.weburl}`">
            <v-list-item-title>
            
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style="
                color: var(--B, #000000);
                leading-trim: both;

                text-edge: cap;
                font-family: Roboto;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 48px; /* 300% */
                letter-spacing: 0.16px;">{{ item.name }}</span>
            
            </v-list-item-title>
          </router-link>
          </v-list-item>
        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
  <!-- /Sidebar -->
</template>
<script>
import axios from 'axios'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import { getData } from '../service/CallWebService'
export default {
  components: {
    vueCustomScrollbar,
  },

  created() {
    this.menuList = JSON.parse(localStorage.getItem('Menu'))
    for (let i = 0; i < this.menuList.length; i++) {
      if (this.menuList[i].essmenu_value === 'CPO') {
        this.CPO = true
        this.CPOname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'CDO') {
        this.CDO = true
        this.CDOname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'AIS') {
        this.AIS = true
        this.AISname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'CD') {
        this.CD = true
        this.CDname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'OC') {
        this.OC = true
        this.OCname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'VI') {
        this.VI = true
        this.VIname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'PR') {
        this.PR = true
        this.PRname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'LEV') {
        this.LEV = true
        this.LEVname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'DOC') {
        this.DOC = true
        this.DOCname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'ONB') {
        this.ONB = true
        this.ONBname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'SAS') {
        this.SAS = true
        this.SASname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'RP') {
        this.RP = true
        this.RPname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'CON') {
        this.CON = true
        this.CONname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'AT') {
        this.AT = true
        this.ATname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'HM') {
        this.HM = true
        this.HMname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      } else if (this.menuList[i].essmenu_value === 'LA') {
        this.LA = true
        this.LAname = this.menuList[i].name
          .toLowerCase()
          .replace(/(^|\s)[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      }
    }
  },

  mounted() {
    this.userimage = JSON.parse(localStorage.getItem('userimage'))
    console.log('console', this.userimage)
    this.username = JSON.parse(localStorage.getItem('username'))
    this.userrole = JSON.parse(localStorage.getItem('job'))

    $('#sidebar-menu a').on('click', function (e) {
      if ($(this).parent().hasClass('submenu')) {
        e.preventDefault()
      }
      if (!$(this).hasClass('subdrop')) {
        $('ul', $(this).parents('ul:first')).slideUp(350)
        $('a', $(this).parents('ul:first')).removeClass('subdrop')
        $(this).next('ul').slideDown(350)
        $(this).addClass('subdrop')
      } else if ($(this).hasClass('subdrop')) {
        $(this).removeClass('subdrop')
        $(this).next('ul').slideUp(350)
      }
    })
    $('#sidebar-menu ul li.submenu a.active')
      .parents('li:last')
      .children('a:first')
      .addClass('active')
      .trigger('click')
  },
  computed: {
    currentpage() {
      return this.$route.path
    },
  },
  data: function () {
    return {
      settings: {
        suppressScrollX: true,
      },
      activeClass: 'active',
      slash: '/',
      menuList: '',
      userimage: '',
      username: '',
      userrole: '',
      logindetails: '',
      roles: '',
      jwt: '',
      AIS: false,
      AISname: '',
      AT: false,
      VI: '',
      VIname: '',
      ATname: '',
      HM: false,
      HMname: '',
      CDO: false,
      CDOname: '',
      CON: false,
      CPO: false,
      CPOname: '',
      DOC: false,
      DOCname: '',
      LEV: false,
      LEVname: '',
      ONB: false,
      ONBname: '',
      PR: false,
      PRname: '',
      RP: false,
      RPname: '',
      SAS: false,
      SASname: '',
      CD: false,
      CDname: '',
      OC: false,
      OCname: '',
      LA: false,
      LAname: '',
      isActive: null,
      activelist:JSON.parse(localStorage.getItem('activelist'))
    }
    //  isactive : true
  },
  methods: {
    onItemClick(item) {
      localStorage.setItem('role', JSON.stringify(item.weburl))
      //this.$router.push('/'+item.weburl)
      this.isActive = item
    },
    scrollHanle(evt) {
      console.log(evt)
    },
    checkuserimg(img) {
      if (img.length > 22) {
        return true
      } else {
        return false
      }
    },
    checkimg(img) {
      if (img === 'data:image/jpg;base64,' || img === 0) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<style>
li {
  cursor: pointer;
  /* Add other styles for your navbar items */
}
.gdg {
  background-color: #6e0a0a;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue